import { ArrowCounterClockwise, ChartBar, Van } from '@phosphor-icons/react'
import type { ConsoleDetailRoute, ConsoleSection } from '../routes'
import { DispatchesPage } from '../pages/recall/DispatchesPage'
import { DispatchDetailPage } from '../pages/recall/DispatchDetailPage'
import { RecallPage } from '../pages/recall/RecallPage'
import { LotBalancePage } from '../pages/recall/LotBalancePage'
import { LotBalanceDetailPage } from '../pages/recall/LotBalanceDetailPage'

/** Sidebar entries for this area (in sidebar order). F7.8 dispatch, F7.9 recall and lot balance. */
export const RECALL_SECTIONS: ConsoleSection[] = [
  { path: 'dispatches', label: 'Dispatches', icon: Van, group: 'Pack & lab', element: <DispatchesPage /> },
  { path: 'recall', label: 'Recall', icon: ArrowCounterClockwise, group: 'Pack & lab', element: <RecallPage /> },
  { path: 'lot-balance', label: 'Lot balance', icon: ChartBar, group: 'Pack & lab', element: <LotBalancePage /> },
]

/** Detail pages for this area: routed, not in the sidebar. */
export const RECALL_DETAIL_ROUTES: ConsoleDetailRoute[] = [
  { path: 'dispatches/:id', element: <DispatchDetailPage /> },
  { path: 'lot-balance/:id', element: <LotBalanceDetailPage /> },
]
